jQuery(function($) {

    var delayTimer;

    function sendRequest() {
        var filter = $('#filter3');
        $('#loading').show();
        $.ajax({
            url: filter.attr('action'),
            data: filter.serialize(), // form data
            type: filter.attr('method'), // POST
            dataType: 'json', // Set the expected response data type
            success: function(response) {
                $('#response').html(response.result);

                //filterTuotekategoriat(response.tuotekategoriat);

            },
            complete: function() {
                // Hide the loading GIF image after the request is complete
                $('#loading').hide();
            }
        });
    }

    sendRequest();

    $('#filter3 .henkilot-select').on('change', function() {
        clearTimeout(delayTimer);
        delayTimer = setTimeout(sendRequest, 500);
    });


    $('#filter3 .henkilot-select, #filter3 .search-input').on('keyup change click', function() {
        clearTimeout(delayTimer); // Clear the previous timer
        delayTimer = setTimeout(sendRequest, 500); // Set a delay of 500 milliseconds before sending the request
    });

    var hakusanakentta = document.getElementById("hakusanakentta");

    if (hakusanakentta) {
        hakusanakentta.addEventListener("keydown", function(event) {
        if (event.key === "Enter") {
            event.preventDefault(); // Prevent form submission
        }
        });
    }



});

